import TranslatedText from '@sms/plasma-ui/lib/components/TranslatedText/TranslatedText';
import React, { FC } from 'react';

import { IMMStatistics, TSegStatistics } from '../../../../../store/api/segregation/types';

interface IProps {
  statistics: TSegStatistics;
  mmStatistics: IMMStatistics | null | undefined;
}

export const AreaRow: FC<IProps> = ({ statistics, mmStatistics }) => {
  return (
    <>
      {statistics && 'area' in statistics && (
        <li className="seg__statistics__item">
          <p>
            <TranslatedText textKey="side-menu.area" />  [mm<sup>2</sup>]:
          </p>
          <p>{statistics?.area + `${mmStatistics ? ` (${mmStatistics?.area})` : ''}`}</p>
        </li>
      )}
    </>
  );
};
